/** Regex that checks for h1's and h2's in html. */
export const regexIncludeH1H2Tag = /<h[12]>/i;
